import { ProductSlider } from './ProductSlider'
import { useProductAttributes } from '../../../state'

export function CrossSellProducts() {
  const { crossSellProducts, loadingRelated } = useProductAttributes()

  return (
    <ProductSlider
      products={crossSellProducts}
      loading={loadingRelated}
      title="Alti clienti au mai cumparat"
    />
  )
}
